import { render, staticRenderFns } from "./PesquisaLegislacaoMunicipalShow.vue?vue&type=template&id=c7690d98&scoped=true"
import script from "./PesquisaLegislacaoMunicipalShow.vue?vue&type=script&lang=js"
export * from "./PesquisaLegislacaoMunicipalShow.vue?vue&type=script&lang=js"
import style0 from "./PesquisaLegislacaoMunicipalShow.vue?vue&type=style&index=0&id=c7690d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7690d98",
  null
  
)

export default component.exports